import actions from '@/store/modules/mobile/dashboard/dashboard.actions';
import mutations from '@/store/modules/mobile/dashboard/dashboard.mutations';
import getters from '@/store/modules/mobile/dashboard/dashboard.getters';

export interface State {}

const initialState: State = {};

export default {
  namespaced: true,
  state: initialState,
  actions,
  mutations: mutations,
  getters
};
